import { connect } from "react-redux";

import { RootState } from "store/store";
import { getIsLoaderVisible } from "store/common/initialization/initialization-selectors";

import Preloader from "./Preloader";

const mapStateToProps = (state: RootState) => {
    return {
        isLoaderVisible: getIsLoaderVisible(state),
    };
};

const PreloaderContainer = connect(mapStateToProps)(Preloader);

export default PreloaderContainer;
